/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { FunctionComponent } from 'react';

import { Locale } from '../../../core/locale';
import { PreviewComponentAssets } from '../../../core/usecases';
import { DateTime } from '../../../core/utils';

/**
 * FirstArisOrAired displays the first aired date as a styled caption.
 * @param firstAiredDate - The first aired date as a string.
 * @param className - Optional CSS class for custom styling.
 */
const FirstAirsOrAired: FunctionComponent<{ firstAiredDate?: string; className?: string }> = ({
    firstAiredDate,
    className: aClassName = '',
}) => {
    if (!firstAiredDate) return null;
    const oFirstAiredDate = new DateTime(firstAiredDate);
    const isUpcoming: boolean = oFirstAiredDate.getTime() > DateTime.now();
    const displayText = isUpcoming
        ? Locale.getString(PreviewComponentAssets.StringAssets.FIRST_AIRS_DATE)
        : Locale.getString(PreviewComponentAssets.StringAssets.FIRST_AIRED_DATE);

    const defaultClassName = 'primary-text-style muted-color text-light';
    return (
        <span className={`uikit ${aClassName || defaultClassName}`}>
            {displayText
                .replace(
                    PreviewComponentAssets.Placeholders.AIRDATE,
                    oFirstAiredDate.strftime('%m/%d/%Y'),
                )
                .replace(':', '')}
        </span>
    );
};

export default FirstAirsOrAired;
